/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listTemplates.defs.js'
export * as $defs from './listTemplates.defs.js'
